import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { categoryName } from "../data/site";

export function ProductCard({ product }) {
  return (
    <article className="card" data-testid={`product-card-${product.slug}`}>
      <Link to={`/products/${product.slug}`} className="card-img">
        <img src={product.image} alt={product.alt} loading="lazy" />
      </Link>
      <div className="card-body">
        <span className="card-cat">{categoryName(product.category)}</span>
        <h3>{product.name}</h3>
        <p>{product.short}</p>
        <Link to={`/products/${product.slug}`} className="card-link" data-testid={`view-product-${product.slug}`}>
          View Product <ArrowRight size={14} />
        </Link>
      </div>
    </article>
  );
}
